// REACT_APP_API_HOST is used when the address the app is served from has to
// differ from the API address (e.g. serving from a subdomain to test passkeys).
let apiAddress = process.env.REACT_APP_API_HOST || window.location.hostname;
if (apiAddress === "localhost") {
  apiAddress = "mail.devx.uzop.net";
}

export const hostname = apiAddress;
export const baseURL = `https://${apiAddress}`;
export const apiUrl = `https://${apiAddress}/api/v1k`;
export const archiveApiUrl = `https://${apiAddress}/api/v1`;
export const apiV2Url = `https://${apiAddress}/api/v2`;
export const socketUrl = `wss://${apiAddress}`;
export const serverTimezone = "Europe/Istanbul";

export const sentryUrl =
  window?.runConfig?.sentryDsn || process.env.REACT_APP_SENTRY_DSN;
export const resendTimeOut =
  (window?.runConfig?.resendTimeOut || process.env.REACT_APP_RESEND_CODE_TIME) *
  1000;
